import { EditableMissionState } from '../mission/model/EditableMissionState';
import { AIRCRAFT_DEFAULT_LABELS, AIRCRAFT_STATUS_LABELS } from './labels';
import { AircraftResponse } from './FleetManagmentClient';

export const AircraftInMissionDetails: React.FC<{ aircraft: AircraftResponse; mission: EditableMissionState; }> = ({ aircraft, mission }) => {
    let secondary = '';
    if (!mission.hasEnded() && aircraft.status === 'grounded'){
        secondary = AIRCRAFT_STATUS_LABELS['grounded'];
    }
    if (aircraft.make || aircraft.model){
        const space = aircraft.make ? ' ' : '';
        secondary = `${aircraft.make}${space}${aircraft.model}`;
    }
    else if (aircraft.serial){
        secondary = aircraft.serial;
    }

    return (
        <p>
            {aircraft.defaultType ? `${AIRCRAFT_DEFAULT_LABELS[aircraft.defaultType]}: ` : ''}{aircraft.nickname} {secondary && <span>({ secondary })</span>}
        </p>
    );
};
